import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { SESSION_EXPIRED_MSG } from '@shared/constant/shared.constant';
import { AuthService } from '@core/services/auth.service';
import { ToastService } from '@shared/services/toast.service';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { LoaderService } from '@shared/services/loader.service';

const EXCLUDED_APIS: string[] = [
    '/ParkingLot/GetAllPakingLot'
];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    sessionExpiredMsg = SESSION_EXPIRED_MSG;
    private activeRequests: number = 0;
    constructor(
        private readonly authService: AuthService,
        private readonly loaderService: LoaderService,
        private readonly toastService: ToastService,
        private readonly dialogControlService: DialogControlService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let interceptorParam = req.headers.get('isLoaderStop') === 'true';
        if (!interceptorParam) {
            this.activeRequests++;
            this.loaderService.showLoader();
        }

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                const isExcluded = EXCLUDED_APIS.some(api => req.url.includes(api));
                    if (!isExcluded && error instanceof HttpErrorResponse && error.status === 401) {
                        this.dialogControlService.onClose();
                        this.authService.handleSessionExpiry(this.toastService);
                    }
                return throwError(() => error);
            }),
            finalize(() => {
            if (!interceptorParam) {
                this.activeRequests--;
                if (this.activeRequests === 0) {
                    this.loaderService.hideLoader();
                }
            }
            })
        );
    }
}
